import React from "react";
import config from './../../config.js';
import Loading from './../../../components/loading.js';

export default class Tagsubject extends React.Component {
    constructor(props) {
        super(props);
        let user = {};
        if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
            user = JSON.parse(localStorage.user);
        }

        let subject_tagids = [];
        if (props.subject.subject_tags.length) {
            props.subject.subject_tags.map((t, i) => {
                subject_tagids.push(t.id);
            })

        }

        this.state = {
            user: user,
            tags: [],
            subject: props.subject,
            subject_tagids: subject_tagids, //subject has tag ids
            tagids: props.subject.tagids //checked tag ids
        }
        this.handleInputChange = this.handleInputChange.bind(this);

    }

    componentDidMount() {
        this.onInitial();
    }

    componentWillReceiveProps(nextProps) {
        let tags = this.state.tags;
        console.log(nextProps.subject.tagids)
        //let subject_tags = nextProps.subject.subject_tags;
        tags.map((t, i) => {
            if (nextProps.subject.tagids.indexOf(t.id) >= 0) {
                t.checked = true;
            } else {
                t.checked = false;
            }
            return t;
        });

        this.setState({
            subject: nextProps.subject,
            tagids: nextProps.subject.tagids,
            tags: tags
        });

    }

    handleInputChange(event) {
        this.props.handleInputChange(event)
    }

    onInitial() {
        const me = this;
        const {
            user,
            tagids
        } = me.state;

        const postdata = {
            userid: user.id,
            request: 'list',
            Authorization: localStorage.token
        };
        me.setState({
            loading: true
        });
        fetch(config.host + '/tags/index', {
                method: 'post',
                body: JSON.stringify(postdata)
            })
            .then(res => res.json())
            .then(json => {
                console.log(json);
                if (json.status === 1) {
                    let data = json.data;
                    data.map((d, i) => {
                        if (tagids.indexOf(d.id) >= 0) d.checked = true;
                        return d;
                    })
                    me.setState({
                        tags: data,
                        loading: false
                    });

                } else {
                    me.setState({
                        tags: [],
                        loading: false
                    });
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    render() {
        let {
            tags
        } = this.state;
        return (<div>
            <div className="form-row align-items-center">
            {
                        tags.length > 0 && tags.map((p,i)=>{
                            return(
                                <div className="col-auto" key={i}>
                                    <div className="custom-control custom-checkbox mr-sm-2">
                                    <input name="tagid" type="checkbox" className="custom-control-input" id={p.id} value={p.id} checked={p.checked} onChange={this.handleInputChange} />
                                    <label className="custom-control-label" htmlFor={p.id}>{p.name}</label>
                                  </div> 
                                </div>)
                        })
            }
            </div>
            <div className="form-inline my-3 py-3">
                <div className="form-group mb-2">
                <span className="form-control-plaintext">标签:</span>
              </div> <div className = "form-group mx-sm-3 mb-2" >
            <input type="text" className="form-control" id="name" name="tagname" placeholder="添加标签名称..."  onChange={this.handleInputChange} /> </div> </div>


        </div>)
    }

}


// WEBPACK FOOTER //
// ./src/apps/console/uncategorized/tag_subject.js